/**
 * Switch Component - Controller
 * =============================
 */

import type { IScope, INgModelController, ITranscludeFunction } from 'angular';
import { SIZES, BASE_CLASSES, DEFAULTS, SwitchSize } from './constants';

export interface SwitchBindings {
  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  size?: SwitchSize;
  inputId?: string;
  onChange?: (args: { checked: boolean }) => void;
}

export class SwitchController implements SwitchBindings {
  static $inject = ['$scope', '$transclude'];

  private $scope: IScope | null;
  private $transclude: ITranscludeFunction | null;

  ngModelCtrl?: INgModelController | null;

  label?: string;
  ariaLabel?: string;
  disabled?: boolean;
  size?: SwitchSize;
  inputId?: string;
  onChange?: (args: { checked: boolean }) => void;

  checked = false;
  focused = false;
  resolvedId = '';

  // Slot nombrado (label): detectado con isSlotFilled, que SÍ funciona
  // para multi-slot transclusion (a diferencia del slot default booleano).
  hasLabelSlot = false;

  constructor($scope: IScope, $transclude: ITranscludeFunction) {
    this.$scope = $scope;
    this.$transclude = $transclude;
  }

  $onInit(): void {
    this.size = this.size || DEFAULTS.size;
    const uid = this.$scope ? String(this.$scope.$id) : Math.random().toString(36).slice(2);
    this.resolvedId = this.inputId || ('ec-switch-' + uid);
    if (this.$transclude) {
      this.hasLabelSlot = this.$transclude.isSlotFilled('labelSlot');
    }
    if (this.ngModelCtrl) {
      this.ngModelCtrl.$render = () => {
        this.checked = !!(this.ngModelCtrl && this.ngModelCtrl.$viewValue);
      };
    }
  }

  $onDestroy(): void {
    this.$scope = null;
    this.$transclude = null;
    this.ngModelCtrl = null;
  }

  handleChange(): void {
    if (this.ngModelCtrl) {
      this.ngModelCtrl.$setViewValue(this.checked);
    }
    if (typeof this.onChange === 'function') {
      this.onChange({ checked: this.checked });
    }
  }

  getWrapperClasses(): string[] {
    const classes = [BASE_CLASSES.wrapper];
    if (this.disabled) classes.push(BASE_CLASSES.wrapperDisabled);
    return classes;
  }

  getTrackClasses(): string[] {
    const classes = [BASE_CLASSES.track, SIZES[this.size || DEFAULTS.size].track];
    classes.push(this.checked ? BASE_CLASSES.trackOn : BASE_CLASSES.trackOff);
    if (this.focused) classes.push(BASE_CLASSES.trackFocused);
    return classes;
  }

  getKnobClasses(): string[] {
    const classes = [BASE_CLASSES.knob, SIZES[this.size || DEFAULTS.size].knob];
    classes.push(this.checked ? BASE_CLASSES.knobOn : BASE_CLASSES.knobOff);
    return classes;
  }

  getLabelClasses(): string[] {
    return [SIZES[this.size || DEFAULTS.size].label, BASE_CLASSES.label];
  }
}

export default SwitchController;
